import { render, staticRenderFns } from "./DisplayImage.vue?vue&type=template&id=2f6c37f4&scoped=true&"
import script from "./DisplayImage.vue?vue&type=script&lang=ts&"
export * from "./DisplayImage.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayImage.vue?vue&type=style&index=0&id=2f6c37f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c37f4",
  null
  
)

export default component.exports